var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaiichi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 321.191,
    height: 314.616,
    viewBox: "0 0 321.191 314.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1290.048,
    cy: 1561.086,
    r: 2105.252,
    gradientTransform: "translate(0.038) scale(0.925 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#2dafe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#2caae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#2c9bd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#2a84c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#2963ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#27398f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27348b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.498,
    r: 0.422,
    gradientTransform: "translate(-0.283) scale(1.567 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.458,
    cy: 2.182,
    r: 2.194,
    gradientTransform: "translate(0.342) scale(0.315 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#ffed00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#faeb01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#ebe704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#d4df0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#b3d511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#89c91b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#55b928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#19a636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13a538"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.502,
    cy: 0.426,
    r: 0.583,
    gradientTransform: "translate(0.061) scale(0.878 1)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48055",
    "data-name": "Group 48055",
    transform: "translate(-1014.417 1154.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48053",
    "data-name": "Group 48053",
    transform: "translate(1095.575 -1154.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64679",
    "data-name": "Path 64679",
    d: "M1048.55-1141.843l-.062.057.043-.017Z",
    transform: "translate(-1048.488 1172.356)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64680",
    "data-name": "Path 64680",
    d: "M1121.677-1134.582l-.008-.027-.009,0Z",
    transform: "translate(-947.363 1182.354)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64681",
    "data-name": "Path 64681",
    d: "M1126.56-1117.181c41.145,26.533,79.783,16.674,96.2,10.276a118.091,118.091,0,0,0-94.948-47.747,117.832,117.832,0,0,0-79.286,30.513l-.019.041A87.555,87.555,0,0,1,1126.56-1117.181Z",
    transform: "translate(-1048.463 1154.653)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64682",
    "data-name": "Path 64682",
    d: "M1245.371-1124.644a106.194,106.194,0,0,1,3.954,28.734,94.612,94.612,0,0,1-94.612,94.612,94.612,94.612,0,0,1-94.612-94.612c0-16.012,3.942-32.689,10.964-45.909h0c-23.9,21.638-38.915,54.527-38.915,89.307a118.263,118.263,0,0,0,118.263,118.263,118.263,118.263,0,0,0,118.263-118.263C1268.677-1078.926,1260.009-1104.959,1245.371-1124.644Z",
    transform: "translate(24.509 17.737)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48054",
    "data-name": "Group 48054",
    transform: "translate(1014.417 -898.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64683",
    "data-name": "Path 64683",
    d: "M1015.894-1024.741v-2.422c0-10.631,0-16.6-1.477-18.132h4.311c4.9,0,9.214-.71,13.113-.71,11.046,0,17.425,6.97,17.425,17.9,0,12.818-7.856,20.969-20.674,20.969-3.957,0-7.325-.3-10.159-.3h-4.016C1015.834-1008.913,1015.894-1014.584,1015.894-1024.741Zm5.079-5.967v8.623c0,5.376.119,8.742.3,9.983.3,2.008,1.832,2.479,6.853,2.479,9.685,0,15.121-6.141,15.121-16.6,0-10.986-5.731-17.248-15.948-17.248a27,27,0,0,0-5.848.59A89.235,89.235,0,0,0,1020.972-1030.708Z",
    transform: "translate(-1014.417 1048.841)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64684",
    "data-name": "Path 64684",
    d: "M1045.5-1018.372a8.094,8.094,0,0,1-7.5,4.962c-4.193,0-7.442-2.952-7.442-6.2,0-3.9,3.661-5.729,9.745-8.387,4.314-1.892,5.257-2.482,5.257-5.908,0-3.721-1.534-5.374-4.962-5.374a4.271,4.271,0,0,0-3.6,1.593c-.886,1.241-1.062,3.9-3.485,3.9a2.078,2.078,0,0,1-2.187-2.187c0-2.775,3.9-5.2,11.224-5.2,5.257,0,7.322,1.653,7.322,5.671,0,1.949-.3,5.729-.3,11.518,0,5.729.651,9.037,2.01,9.864l-5.316.355A15.218,15.218,0,0,1,1045.5-1018.372Zm-10.1-2.361c0,2.244,1.831,3.837,4.607,3.837,3.723,0,5.376-2.363,5.376-7.265v-4.133C1039.006-1025.754,1035.4-1024.277,1035.4-1020.733Z",
    transform: "translate(-992.108 1055.523)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64685",
    "data-name": "Path 64685",
    d: "M1041.147-1042.658l4.431-2.777,2.479,4.076-4.371,2.718Zm1.713,26.933v-8.978c0-5.907-.06-9.156-1.241-9.923a30.434,30.434,0,0,0,5.788-.65c-.236,2.067-.295,7.5-.295,16.3v3.366c0,4.016.119,6.5,1.241,7.384h-6.734C1042.741-1009.05,1042.86-1011.532,1042.86-1015.725Z",
    transform: "translate(-977.475 1049.628)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64686",
    "data-name": "Path 64686",
    d: "M1046.354-1042.658l4.431-2.777,2.479,4.076-4.371,2.718Zm1.713,26.933v-8.978c0-5.907-.06-9.156-1.241-9.923a30.44,30.44,0,0,0,5.789-.65c-.236,2.067-.3,7.5-.3,16.3v3.366c0,4.016.119,6.5,1.241,7.384h-6.734C1047.947-1009.05,1048.067-1011.532,1048.067-1015.725Z",
    transform: "translate(-970.279 1049.628)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64687",
    "data-name": "Path 64687",
    d: "M1072.212-1019.847c0,4.016-3.6,6.437-8.683,6.437-6.731,0-12.167-5.255-12.167-13.349,0-8.5,5.848-14.411,14.059-14.411a20.9,20.9,0,0,1,5.729.71l-.176,6.2c-1.065-3.19-3.014-4.843-5.848-4.843-5.138,0-8.859,4.607-8.859,11.991,0,6.26,3.661,10.455,8.74,10.455a8.841,8.841,0,0,0,7.206-3.309Z",
    transform: "translate(-963.358 1055.523)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64688",
    "data-name": "Path 64688",
    d: "M1063.31-1016.246c0-4.371-.119-10.1-.119-17.248v-4.783c0-4.431-.119-7.029-1.241-7.916l5.848-1-.472,19.078c2.6-3.368,4.962-4.726,8.623-4.726a5.914,5.914,0,0,1,6.083,4.312c.532,1.655.591,4.962.591,9.983v6.556c0,3.073.059,5.138,1.241,6.2h-5.789c.236-4.076.3-9.923.3-17.544,0-4.252-1.124-6.2-5.021-6.2-5.907,0-5.907,4.133-5.907,10.571v5.671c0,4.193.119,6.674,1.241,7.5h-6.734C1063.072-1006.442,1063.31-1009.867,1063.31-1016.246Z",
    transform: "translate(-948.725 1047.196)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64689",
    "data-name": "Path 64689",
    d: "M1073.207-1042.658l4.431-2.777,2.482,4.076-4.371,2.718Zm1.713,26.933v-8.978c0-5.907-.057-9.156-1.239-9.923a30.454,30.454,0,0,0,5.788-.65c-.236,2.067-.3,7.5-.3,16.3v3.366c0,4.016.117,6.5,1.239,7.384h-6.731C1074.8-1009.05,1074.92-1011.532,1074.92-1015.725Z",
    transform: "translate(-933.167 1049.628)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64690",
    "data-name": "Path 64690",
    d: "M1080.815-1036.212h13.408l-2.539,3.545h-12.463a1.918,1.918,0,0,1-1.005-.177Z",
    transform: "translate(-926.245 1062.376)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64691",
    "data-name": "Path 64691",
    d: "M1086.5-1015.411a11.84,11.84,0,0,0,10.631,6.024c4.726,0,7.737-3.13,7.737-7.205,0-3.542-2.184-5.789-6.32-8.032-6.143-3.366-10.75-5.612-10.75-11.517,0-5.493,4.607-9.864,12.286-9.864,3.011,0,5.138.236,6.26.236.3,0,.651.059,1.122.059h1.477v6.143c-1.477-2.482-4.192-3.839-7.8-3.839-5.2,0-7.973,2.539-7.973,5.964,0,4.195,3.6,5.967,8.208,8.387,6.024,3.189,9.1,6.263,9.1,10.87,0,6.084-5.612,11.458-13.525,11.458a30.048,30.048,0,0,1-10.454-2.244Z",
    transform: "translate(-914.799 1048.841)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64692",
    "data-name": "Path 64692",
    d: "M1113.044-1018.372a8.09,8.09,0,0,1-7.5,4.962c-4.192,0-7.441-2.952-7.441-6.2,0-3.9,3.661-5.729,9.745-8.387,4.312-1.892,5.257-2.482,5.257-5.908,0-3.721-1.536-5.374-4.962-5.374a4.269,4.269,0,0,0-3.6,1.593c-.886,1.241-1.065,3.9-3.485,3.9a2.078,2.078,0,0,1-2.187-2.187c0-2.775,3.9-5.2,11.222-5.2,5.257,0,7.325,1.653,7.325,5.671,0,1.949-.3,5.729-.3,11.518,0,5.729.65,9.037,2.008,9.864l-5.314.355A15.311,15.311,0,0,1,1113.044-1018.372Zm-10.1-2.361c0,2.244,1.831,3.837,4.606,3.837,3.721,0,5.376-2.363,5.376-7.265v-4.133C1106.548-1025.754,1102.945-1024.277,1102.945-1020.733Z",
    transform: "translate(-898.762 1055.523)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64693",
    "data-name": "Path 64693",
    d: "M1109.93-1021.619v-7.5c0-6.5-.057-9.983-1.241-10.81l5.376-.591a13.457,13.457,0,0,1,.3,2.954v.767c2.363-3.071,4.843-4.371,8.328-4.371,6.143,0,6.674,4.547,6.674,13.409v7.677c0,3.013.059,4.962,1.241,5.967h-5.788c.236-5.021.3-9.924.3-14.709v-1.417c0-4.959-.176-7.618-5.021-7.618-5.905,0-5.905,4.133-5.905,10.571v5.672c0,4.193.117,6.674,1.239,7.5h-6.734C1109.813-1014.945,1109.93-1017.427,1109.93-1021.619Z",
    transform: "translate(-884.13 1055.523)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64694",
    "data-name": "Path 64694",
    d: "M1121.553-1014.948c0-2.951-.057-6.674-.057-11.1,0-4.254.057-7.8.057-10.691,0-5.376-.236-8.506-1.829-9.568l6.024-.886v25.869c5.493-3.837,8.151-7.382,8.151-9.213a2.821,2.821,0,0,0-.474-1.653h5.967l-7.62,8.151a28.24,28.24,0,0,1-2.244,2.068c7.265,9.273,10.455,15.357,12.522,16.184h-6.143l-8.682-13.113c-.474-.767-.946-1.182-1.3-1.182-.06,0-.117.059-.176.059v6.734c0,4.193.116,6.674,1.238,7.5h-6.732C1121.377-1006.5,1121.553-1009.572,1121.553-1014.948Z",
    transform: "translate(-868.879 1047.196)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64695",
    "data-name": "Path 64695",
    d: "M1151.407-1038.507a4.424,4.424,0,0,0-.531-2.184h6.143c-2.6,3.01-4.726,10.159-8.8,20.435-6.083,15.476-10.691,23.213-18.132,23.213-3.132,0-5.081-1.537-5.081-2.894,0-.946.946-1.063,3.013-1.063,1.062,0,1.949.06,2.6.06,3.247,0,5.079-.236,6.97-2.6,3.307-4.076,4.724-8.33,4.724-10.514,0-.767-1.241-7.442-5.078-18.782-1.6-4.666-2.539-7.265-3.721-7.739l4.076-.472h.531c1.713,0,3.07,7.442,7.441,22.741C1149.754-1029.587,1151.407-1036.44,1151.407-1038.507Z",
    transform: "translate(-861.581 1055.694)",
    fill: "#27348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64696",
    "data-name": "Path 64696",
    d: "M1163.856-1028.767c0,9.568-5.2,15.357-13.054,15.357-7.679,0-12.11-4.9-12.11-13.349,0-8.919,5.612-14.411,13.292-14.411C1159.485-1041.171,1163.856-1036.445,1163.856-1028.767Zm-20.378.709c0,7.973,3.544,12.4,8.623,12.4,4.607,0,6.969-3.9,6.969-11.577,0-7.087-3.425-11.753-8.092-11.753C1146.2-1038.984,1143.478-1035.263,1143.478-1028.058Z",
    transform: "translate(-842.665 1055.523)",
    fill: "#27348b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiichi);
export default __webpack_public_path__ + "static/media/daiichi.057cdc67a22850c723a8128027a2e14f.svg";
export { ForwardRef as ReactComponent };